import axiosAuth from "@/services/axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { DASHBOARD_PM_DELETE_ATTACHMENT_API } from "./apiRoutes";

interface mutateProps {
  projectId: string;
  taskId: string;
  attachmentId: string;
}

const mutateDeletePMClientAttachment = async ({projectId, taskId, attachmentId}: mutateProps) => {
  return await axiosAuth.delete(DASHBOARD_PM_DELETE_ATTACHMENT_API(projectId, taskId, attachmentId));
};

const useDeletePMClientAttachmentMutation = (
  queryParams?: UseMutationOptions<any, Error, mutateProps, unknown>
) =>
  useMutation({
    mutationFn: mutateDeletePMClientAttachment,
    ...queryParams,
  });

export default useDeletePMClientAttachmentMutation;
